/* eslint-disable prettier/prettier */
import React  from 'react';

import { useTheme } from 'styled-components';
import { ThemeType } from 'theme/theme';

import { ReactComponent as FlightDuotone } from 'assets/images/flight-duotone.svg';
import { Desktop, Mobile } from 'components/Responsive';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { Airport } from 'models/airport';
import { ReactComponent as BackpackActive } from 'assets/images/luggages/backpack-active.svg';
import { ReactComponent as HandLuggageActive } from 'assets/images/luggages/hand-luggage-active.svg';
import { ReactComponent as HandLuggage } from 'assets/images/luggages/hand-luggage.svg';
import { ReactComponent as WarehouseLuggageActive } from 'assets/images/luggages/warehouse-luggage-active.svg';
import { ReactComponent as WarehouseLuggage } from 'assets/images/luggages/warehouse-luggage.svg';
import {
  FlightBySectorGroupedResultResponse,
  /* FlightGroupedResultResponse, */ FlightStretch
} from 'models/flightSearch';
import { getFormattedPrice } from 'utils/currency';

import FlightOption from './FlightOption';
import {
  Card,
  FlightsContainer,
  Summary,
  RouteTypeWrapper,
  RouteTypeText,
  RouteTypeRoot,
  RouteTypeDate,
  RouteTypeHeaderContainer,
  RouteTypeHeaderText,
  FlightsListContainer,
  FinalPriceWithTaxes,
  PriceContainer,
  PriceWrapper,
  Price,
  Currency,
  ConfirmButton,
  FlightsWrapper,
  RouteTypeStartAirportContainer,
  RouteTypeEndAirportContainer,
  RouteTypeCityName,
  SummaryMobile,
  ConfirmButtomMobile,
  FinalPriceWithTaxesMobile,
  BreakRulesMessage,
  NoBreakRulesMessage,
  ConfirmUpSellButton,
  ConfirmUpSellButtomMobile,
  FooterMobile,
  FlightLuggagesContainer,
  TooltipContainer,
  FlightLuggages,
  Restrictions,
} from './styles';
import { getFormattedRouteType } from './utils';
import CollapsibleDetail from './FlightOption/CollapsibleDetail';
//import CollapsibleDetail from './FlightOption/CollapsibleDetail';
import Tooltip from 'components/Tooltips/LuggagesTooltip';
import { List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';

interface Props {
  data: FlightBySectorGroupedResultResponse;
  onClickWithUpSell: (optionId: number, sectorNumber: number) => void;
  testId?: string;
  departurePoint?: Airport;
  arrivalPoint?: Airport;
  departureDate?: Date;
  returnDate?: Date;
  onClickWithoutUpSell: (selectedFlightsKeys: []) => void;
  numberOfTravelers: number;
  flightStretch: FlightStretch;
  onSelectFlight: (optionId: number) => void;
}

const RouteType = ({ label, date, color,data }) => (
  <RouteTypeRoot>
    <RouteTypeWrapper>
      <FlightDuotone fill={color} />
      <RouteTypeText>{label}</RouteTypeText>
    </RouteTypeWrapper>
    <RouteTypeDate>{getFormattedRouteType(data.sector?.flights?.first()?.departureDate)}</RouteTypeDate>
  </RouteTypeRoot>
);

const RouteTypeStartAirport = ({ airport,data }: { airport?: Airport, data }) => (
  <RouteTypeStartAirportContainer>
    <RouteTypeHeaderText>{data.sector?.flights?.first()?.departureAirport}</RouteTypeHeaderText>
    <RouteTypeCityName title={data.sector?.flights?.first()?.departureCityName}>{data.sector?.flights?.first()?.departureCityName}</RouteTypeCityName>
  </RouteTypeStartAirportContainer>
);

const RouteTypeEndAirport = ({ airport,data }: { airport?: Airport, data }) => (
  <RouteTypeEndAirportContainer>
    <RouteTypeHeaderText>{data.sector?.flights?.last()?.arrivalAirport}</RouteTypeHeaderText>
    <RouteTypeCityName title={data.sector?.flights?.last()?.arrivalCityName}>{data.sector?.flights?.last()?.arrivalCityName }</RouteTypeCityName>
  </RouteTypeEndAirportContainer>
);

const RouteTypeHeader = ({
  routeType,
  date,
  airports: [departureAirport, arrivalAirport],
  color,
  data
}: {
  routeType: string;
  date: string;
  airports: [Airport?, Airport?];
  color: string;
  data
}) => {
  const { t } = useStoreTranslation();
  const theme = useTheme() as ThemeType;
  const haveWarehouseBaggage = !data.sector?.flights?.first()?.baggageRestrictions?.startsWith('0');
  const restrictions = data.sector?.flights?.first()?.baggageRestrictions;

  return (
    <RouteTypeHeaderContainer>
      <RouteType label={routeType} date={date} color={color} data={data} />
      <Desktop>
        <RouteTypeStartAirport airport={departureAirport} data={data} />
        <div />
        <RouteTypeEndAirport airport={arrivalAirport} data={data} />
        <RouteTypeHeaderText>{t('flightsCard.luggage')}
          <FlightLuggagesContainer>
            <Tooltip
              event="hover"
              content={
                <TooltipContainer>
                  <p>{t('flightsCard.luggage')}</p>
                  <List dense disablePadding>
                    <ListItem>
                      <ListItemIcon>
                        <BackpackActive fill={theme.primaryBackgroundColor} stroke={theme.primaryBackgroundColor} />
                      </ListItemIcon>
                      <ListItemText primary={t('luggageInfo.personalArticle')} />
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        {data.sector?.flights?.first()?.handBaggage ? (
                          <HandLuggageActive fill={theme.primaryBackgroundColor} stroke={theme.primaryBackgroundColor} />
                        ) : (
                          <HandLuggage />
                        )}
                      </ListItemIcon>
                      {data.sector?.flights?.first()?.handBaggage ? (
                        <ListItemText primary={t('luggageInfo.handBaggage')} />
                      ) : (
                        <ListItemText primary={t('luggageInfo.NoHandBaggage')} />
                      )}
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        {data.sector?.flights?.first()?.baggageRestrictions && data.sector?.flights?.first()?.baggageRestrictions.startsWith('0') ? (
                          <WarehouseLuggage />
                        ) : (
                          <WarehouseLuggageActive
                            fill={theme.primaryBackgroundColor}
                            stroke={theme.primaryBackgroundColor}
                          />
                        )}
                      </ListItemIcon>
                      {data.sector?.flights?.first()?.baggageRestrictions && data.sector?.flights?.first()?.baggageRestrictions.startsWith('0') ? (
                          <ListItemText primary={t('luggageInfo.NoCheckedBaggage')} />
                        ) : (
                          <ListItemText primary={t('luggageInfo.checkedBaggage')} />
                        )}
                    </ListItem>
                    {haveWarehouseBaggage && (
                      <ListItem>
                        <ListItemIcon>
                          <Restrictions>{t('flightSectorBaggage.restriction', {
                            restrictions: restrictions,
                          })}
                          </Restrictions>                        
                        </ListItemIcon>
                        <ListItemText primary='' />
                      </ListItem>
                    )}
                  </List>
                </TooltipContainer>
              }
            >
              <FlightLuggages>
                <BackpackActive fill={theme.primaryBackgroundColor} stroke={theme.primaryBackgroundColor} />
                {data.sector?.flights?.first()?.handBaggage ? (
                  <HandLuggageActive fill={theme.primaryBackgroundColor} stroke={theme.primaryBackgroundColor} />
                ) : (
                  <HandLuggage />
                )}
                {data.sector?.flights?.first()?.baggageRestrictions && data.sector?.flights?.first()?.baggageRestrictions.startsWith('0') ? (
                  <WarehouseLuggage />
                ) : (
                  <WarehouseLuggageActive fill={theme.primaryBackgroundColor} stroke={theme.primaryBackgroundColor} />
                )}
              </FlightLuggages>
            </Tooltip>
  
          </FlightLuggagesContainer>
        </RouteTypeHeaderText>
      </Desktop>
    </RouteTypeHeaderContainer>
  );
};


const CardGroupedFlightsBySector = ({
  data,
  onClickWithUpSell,
  testId,
  arrivalPoint,
  departureDate,
  departurePoint,
  returnDate,
  onClickWithoutUpSell,
  numberOfTravelers,
  flightStretch,
  onSelectFlight,
}: Props) => {
  const { t } = useStoreTranslation();
  const {
    sectors: [departureFlights, returnFlights],
    price: { total, currencyCode } = {
      total: 0,
      currencyCode: 'BRL',
    },
    breakRulesMessage,
  } = data || {};

  const [newSelectedFlightKeys, setNewSelectedFlightKeys] = React.useState<string[]>(() => {
    const items:string[] = [];
    // const sectors = [];
    // console.log('data',data)
    // for (let index = 0; index < data?.sectors.length; index++) {
    //   const sectors = data.sectors[index];
    //   items.push(sectors?.options?.first().flightKeys);
    // }
    // console.log('items',items)
    items.push(data['flightKey'])
    return items;
  });

  const theme = useTheme() as ThemeType;

  const formattedPrice = (value: number, currencyCode: string) =>
    getFormattedPrice({ value, currency: currencyCode, t });

  //Price
  const formattedPriceTotal = formattedPrice(total, currencyCode);

  const [totalSectors, setTotalSectors] = React.useState(data.totalSectors);
  
  //AlternativePrice
  const formattedAlternativePriceTotal = data.alternativePrice
    ? formattedPrice(data.alternativePrice.total, data.alternativePrice.currencyCode)
    : undefined;

  const handleSelectedFlightKeys = (sectorNumber: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const tempFlightKeys = [...newSelectedFlightKeys];
    tempFlightKeys[sectorNumber - 1] = value;
    setNewSelectedFlightKeys(tempFlightKeys);
  };


  const handleSelectFlightWithoutUpSell = () => {
    onClickWithoutUpSell(newSelectedFlightKeys.map((s) => s?.replaceAll('#', ',')) as unknown as []);

  };

  const handleSelectFlight = (optionId: number) => {
    onSelectFlight(optionId);
  }

  const handleSelectFlightWithUpSell = (optionId: number,sectorNumber: number) => {
    onClickWithUpSell(optionId,sectorNumber);
  }
  return (
    <Card data-testid={testId}>
      <FlightsContainer>
        {/* Ida */}
        {flightStretch !== FlightStretch.MULTIDESTINATION && (
          <FlightsWrapper>
            <RouteTypeHeader
              routeType={data.optionId.toString().charAt(0) === '1' ? t('flightsCard.routeTypeDeparture') : t('flightsCard.routeTypeReturn')}
              date={getFormattedRouteType(departureDate)}
              airports={[departurePoint, arrivalPoint]}
              color={theme.primaryBackgroundColor}
              data={data}
            />
            <FlightsListContainer value={newSelectedFlightKeys[0]} onChange={handleSelectedFlightKeys(1)}>
              {departureFlights?.options?.map((option) => {
                const { flightKeys } = option;
                return <FlightOption key={flightKeys} groupedSectorOption={option} />;
              })}
            </FlightsListContainer>
          <CollapsibleDetail expanded={true} flights={data.sector?.flights} totalDuration={data.sector?.totalDuration} />
          </FlightsWrapper>
        )}

        {/* Si hay vuelta */}
        {flightStretch !== FlightStretch.MULTIDESTINATION && returnFlights && returnFlights?.options && (
          <FlightsWrapper>
            <RouteTypeHeader
              routeType={t('flightsCard.routeTypeReturn')}
              date={getFormattedRouteType(returnDate)}
              airports={[arrivalPoint, departurePoint]}
              color={theme.primaryBackgroundColor}
              data={data}
            />
            <FlightsListContainer value={newSelectedFlightKeys[1]} onChange={handleSelectedFlightKeys(2)}>
              {returnFlights?.options?.map((option) => {
                const { flightKeys } = option;
                return <FlightOption key={flightKeys} groupedSectorOption={option} />;
              })}
            </FlightsListContainer>
            <CollapsibleDetail expanded={true} flights={data.sector?.flights} totalDuration={data.sector?.totalDuration} />
          </FlightsWrapper>
        )}

        {/* Si es Multidestinos */}
        {flightStretch === FlightStretch.MULTIDESTINATION && (
          <>
            <FlightsWrapper>
              <RouteTypeHeader
                routeType={`${t('flightsSearch.sector')} ${data.optionId.toString().charAt(0)}`}
                date={getFormattedRouteType(data.sector?.flights?.first()?.departureDate)}
                data={data}
                airports={[
                  {
                    code: data.sector?.flights?.first()?.departureAirport ?? '',
                    related_city: data.sector?.flights?.first()?.departureCityName ?? '',
                  } as Airport,
                  {
                    code: data.sector?.flights?.last()?.arrivalAirport ?? '',
                    related_city: data.sector?.flights?.last()?.arrivalCityName ?? '',
                  } as Airport,
                ]}
                color={theme.primaryBackgroundColor}
              />
              <FlightsListContainer
                value={newSelectedFlightKeys[data.sector.sectorNumber - 1]}
                onChange={handleSelectedFlightKeys(data.sector.sectorNumber)}
              >
                {/* {data.sectors?.options?.map((option) => {
                  const { flightKeys } = option;
                  return <FlightOption key={flightKeys} groupedSectorOption={option} />;
                })} */}
                
              </FlightsListContainer>
              <CollapsibleDetail expanded={true} flights={data.sector?.flights} totalDuration={data.sector?.totalDuration} />
            </FlightsWrapper>
          </>
        )}
      </FlightsContainer>
      <Desktop>
        <Summary>
          <PriceContainer>
            <PriceWrapper>
              <Price>{formattedPriceTotal?.formattedWithoutCode}</Price>
              <Currency>{formattedPriceTotal?.currency}</Currency>
            </PriceWrapper>

            {data.alternativePrice && (
              <PriceWrapper>
                {t('alternativePrice.or')}
                <Price>{formattedAlternativePriceTotal?.formattedWithoutCode}</Price>
                <Currency>{formattedAlternativePriceTotal?.currency}</Currency>
              </PriceWrapper>
            )}
          </PriceContainer>
          <FinalPriceWithTaxes>
            {t('flightsCard.finalPriceWithTaxes')} {t('flightsCard.toXPassengers', { count: numberOfTravelers ?? 1 })}
          </FinalPriceWithTaxes>
          {breakRulesMessage && breakRulesMessage?.length > 0 ? (
            <BreakRulesMessage>{t('flightDetails.outOfPolicies')}</BreakRulesMessage>
          ) : (
            <NoBreakRulesMessage>{t('flightDetails.withinPolicies')}</NoBreakRulesMessage>
          )}
          {totalSectors <= 2 && (
            <ConfirmButton onClick={() => handleSelectFlight(data.optionId)}>
              {data.optionId.toString().charAt(0) === '1' ? t('flightsCard.selectDepartureFlight') : t('flightsCard.selectReturnFlight')}
            </ConfirmButton>)}

          {totalSectors > 2 && (
          <ConfirmButton onClick={() => handleSelectFlight(data.optionId)}>{t('flightsCard.confirmButton')}</ConfirmButton>)}

          {data.upSellEnabled && (
            <ConfirmUpSellButton value={t('flightsCard.confirmUpSellButton')} onClick={()=>handleSelectFlightWithUpSell(data.optionId,data.sectorNumber)} />
          )}
        </Summary>
      </Desktop>
      <Mobile>
        <SummaryMobile>
          <PriceContainer>
            <PriceWrapper>
              <Price>{formattedPriceTotal?.formattedWithoutCode}</Price>
              <Currency>{formattedPriceTotal?.currency}</Currency>
            </PriceWrapper>

            {data.alternativePrice && (
              <PriceWrapper>
                {t('alternativePrice.or')}
                <Price>{formattedAlternativePriceTotal?.formattedWithoutCode}</Price>
                <Currency>{formattedAlternativePriceTotal?.currency}</Currency>
              </PriceWrapper>
            )}
            <FinalPriceWithTaxesMobile>{t('flightsCard.finalPriceWithTaxes')}</FinalPriceWithTaxesMobile>
            <FinalPriceWithTaxesMobile>
              {t('flightsCard.toXPassengers', { count: numberOfTravelers ?? 1 })}
            </FinalPriceWithTaxesMobile>
            {breakRulesMessage && breakRulesMessage?.length > 0 ? (
              <BreakRulesMessage>{t('flightDetails.outOfPolicies')}</BreakRulesMessage>
            ) : (
              <NoBreakRulesMessage>{t('flightDetails.withinPolicies')}</NoBreakRulesMessage>
            )}
          </PriceContainer>
          <ConfirmButtomMobile onClick={() => handleSelectFlight(data.optionId)}>
            {t('flightsCard.confirmButton')}
          </ConfirmButtomMobile>
        </SummaryMobile>
        {data.upSellEnabled && (
          <FooterMobile>
            <ConfirmUpSellButtomMobile
              value={t('flightsCard.confirmUpSellButton')}
              onClick={() => handleSelectFlightWithUpSell(data.optionId,data.sector.sectorNumber)}  
            />
          </FooterMobile>
        )}
      </Mobile>
    </Card>
  );
};

export default CardGroupedFlightsBySector;
